<template>
  <div>
    <div class="modalAppPublic bg-pink-500" v-if="closeModalAppPublic !== true">
      <div class="container max-w-5xl m-auto text-white px-4 py-3 relative" role="alert">
        <div class="max-w-4xl flex items-center">
          <div class="w-12">
            <svg
              width="23px"
              height="23px"
              viewBox="0 0 23 23"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <title>barify-icon</title>
              <g id="Web-App" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Popup-download-App" transform="translate(-561.000000, -11.000000)">
                  <g id="barify-icon" transform="translate(561.500000, 11.151329)">
                    <circle id="Oval" fill="#FFFFFF" cx="11.0951222" cy="11.0863815" r="10.8721816"></circle>
                    <path
                      d="M11.3009369,9.23897487 C11.3009369,7.93211545 10.3894784,7.26593331 9.51752745,7.26593331 C8.77779307,7.26593331 7.80016575,7.79130984 7.80016575,9.23897487 C7.80016575,10.6866399 8.77779307,11.2120164 9.51752745,11.2120164 C10.3894784,11.2120164 11.3009369,10.5586455 11.3009369,9.23897487 M13.0315081,9.23897487 C13.0315081,11.5708474 11.2878485,12.659799 9.83455647,12.659799 C8.68532628,12.659799 7.98522053,11.9679945 7.87954419,11.5708474 L7.87954419,11.8142601 C7.87954419,12.2754631 7.48313673,12.6469878 7.00747201,12.6469878 C6.54525922,12.6469878 6.12255386,12.2754631 6.12255386,11.8142601 L6.12255386,4.25506743 C6.12255386,3.80655807 6.53192849,3.42222222 7.00747201,3.42222222 C7.46992719,3.42222222 7.86621346,3.80655807 7.86621346,4.25506743 L7.86621346,6.56131759 C7.87954419,6.61244484 7.87954419,6.65087842 7.87954419,6.7021232 L7.87954419,6.92003105 C8.14361385,6.31778735 8.89667896,5.83096194 9.83455647,5.83096194 C11.2745178,5.83096194 13.0315081,6.95846463 13.0315081,9.23897487"
                      id="Fill-19"
                      fill="#D93A58"
                    ></path>
                    <path
                      d="M17.6374776,9.34429588 C17.6374776,9.93127232 17.1793664,10.4068341 16.6139288,10.4068341 C16.0487837,10.4068341 15.5903801,9.93127232 15.5903801,9.34429588 C15.5903801,8.75762301 16.0487837,8.2817577 16.6139288,8.2817577 C17.1793664,8.2817577 17.6374776,8.75762301 17.6374776,9.34429588"
                      id="Fill-31"
                      fill="#D93A58"
                    ></path>
                    <path
                      d="M5.93444533,13.9786554 C6.01898603,13.4568661 6.48698694,13.2141239 6.96117569,13.3444373 C7.40060259,13.4651977 7.70829918,13.8640728 7.64439107,14.3388446 L7.64061056,14.3643503 C7.3247246,16.3148726 9.19190624,17.5871341 11.1229129,16.8816305 C12.9019866,16.231528 14.0881423,14.7723629 15.2398374,12.266838 C15.4604357,11.7868867 15.9757299,11.6723636 16.3993335,11.9181558 C16.8005995,12.1509868 16.99238,12.6284566 16.7858816,13.077959 C16.1316694,14.5011929 15.388955,15.7055881 14.5114596,16.6573162 C13.426443,17.834121 12.1800198,18.5684449 10.753146,18.7687849 C9.31046034,18.9713971 7.92195773,18.5976583 7.00275821,17.6507203 C6.06735985,16.6871436 5.71415394,15.4253363 5.92622763,14.0310046 L5.93444533,13.9786554 Z"
                      id="Fill-33"
                      fill="#D93A58"
                      fill-rule="nonzero"
                    ></path>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div class="w-auto">
            <span class="block md:inline">{{ $t('public.HeaderIntro') }} </span>
            <span class="block md:inline"
              >{{ $t('public.DownloadApp') }} <a :href="linkAppQrApple" class="font-bold text-white">Apple</a> y
              <a :href="linkAppQrAndroid" class="font-bold text-white">Android</a></span
            >
          </div>
          <span class="absolute top-0 bottom-0 right-0 px-4 py-3">
            <svg
              @click="setModalAppPublic(true)"
              class="fill-current h-6 w-6 text-red-100"
              role="button"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <title>{{ $t('Cerrar') }}</title>
              <path
                d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"
              />
            </svg>
          </span>
        </div>
      </div>
    </div>
    <div class="container max-w-5xl m-auto justify-center px-4relative flex" role="alert">
      <a href="/">
        <svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 367.01 254.13" height="120">
          <defs></defs>
          <circle class="cls-1" cx="213.57" cy="154.21" r="7" />
          <path
            class="cls-2"
            d="M29.84,159.47c0,.4-.35.67-.91.67a5.28,5.28,0,0,0-5.11,4.3v7.85a.67.67,0,1,1-1.34,0V159.55a.67.67,0,1,1,1.34,0v2.7a5.52,5.52,0,0,1,5.11-3.45C29.49,158.8,29.84,159.07,29.84,159.47Z"
          />
          <path
            class="cls-2"
            d="M44.32,165.62a.79.79,0,0,1-.89.83H32.27a5.43,5.43,0,0,0,5.57,5.35,5.57,5.57,0,0,0,3.72-1.31c.32-.29.48-.4.67-.4a.53.53,0,0,1,.56.56c0,.22-.08.38-.4.7A6.62,6.62,0,0,1,37.84,173a7.13,7.13,0,1,1,6.48-7.36Zm-12-.35H43a5.38,5.38,0,0,0-10.76,0Z"
          />
          <path
            class="cls-2"
            d="M58.29,169.88a1,1,0,0,1-.22.53A6.16,6.16,0,0,1,52.91,173a7.11,7.11,0,0,1,0-14.21,6.18,6.18,0,0,1,5.16,2.57,1,1,0,0,1,.22.54.58.58,0,0,1-.62.58A.82.82,0,0,1,57,162a4.82,4.82,0,0,0-4-2,5.91,5.91,0,0,0,0,11.8,4.83,4.83,0,0,0,4-2,.82.82,0,0,1,.67-.45A.59.59,0,0,1,58.29,169.88Z"
          />
          <path
            class="cls-2"
            d="M73.73,165.89a6.86,6.86,0,1,1-6.86-7.12A6.89,6.89,0,0,1,73.73,165.89Zm-12.37,0A5.53,5.53,0,1,0,66.87,160,5.59,5.59,0,0,0,61.36,165.89Z"
          />
          <path
            class="cls-2"
            d="M88.34,164.5v7.79a.71.71,0,0,1-.67.69.7.7,0,0,1-.67-.69V164.5c0-3.29-2.09-4.47-4.18-4.47a5.21,5.21,0,0,0-5.08,4.41v7.85a.71.71,0,0,1-.67.69.7.7,0,0,1-.67-.69V159.55a.67.67,0,1,1,1.34,0v2.7A5.53,5.53,0,0,1,83,158.8C85.45,158.8,88.34,160.14,88.34,164.5Z"
          />
          <path
            class="cls-2"
            d="M104.42,165.62a.79.79,0,0,1-.88.83H92.37a5.43,5.43,0,0,0,5.57,5.35,5.56,5.56,0,0,0,3.72-1.31c.32-.29.48-.4.67-.4a.53.53,0,0,1,.56.56c0,.22-.08.38-.4.7A6.62,6.62,0,0,1,97.94,173a7.13,7.13,0,1,1,6.48-7.36Zm-12-.35h10.76a5.38,5.38,0,0,0-10.76,0Z"
          />
          <path
            class="cls-2"
            d="M118.39,169.88a1,1,0,0,1-.22.53A6.16,6.16,0,0,1,113,173a7.11,7.11,0,0,1,0-14.21,6.18,6.18,0,0,1,5.16,2.57,1,1,0,0,1,.22.54.58.58,0,0,1-.62.58.82.82,0,0,1-.67-.45,4.82,4.82,0,0,0-4-2,5.91,5.91,0,0,0,0,11.8,4.83,4.83,0,0,0,4-2,.82.82,0,0,1,.67-.45A.59.59,0,0,1,118.39,169.88Z"
          />
          <path
            class="cls-2"
            d="M126.39,172.05c0,.77-1.37.93-2.17.93a1.93,1.93,0,0,1-2.17-2.17V160.14h-1.47a.58.58,0,0,1-.59-.62.57.57,0,0,1,.59-.59h1.47v-2.62a.67.67,0,1,1,1.34,0v2.62h2.38a.59.59,0,0,1,.62.59.6.6,0,0,1-.62.62h-2.38v10.49c0,.88.4,1.17,1.12,1.17a2.82,2.82,0,0,0,1.07-.21A.56.56,0,0,1,126.39,172.05Z"
          />
          <path
            class="cls-2"
            d="M140,162v-2.41a.69.69,0,0,1,.67-.7.67.67,0,0,1,.67.7v12.76a.7.7,0,0,1-.67.7.71.71,0,0,1-.67-.7v-2.65a5.76,5.76,0,0,1-5.3,3.38,7.15,7.15,0,0,1,0-14.27A5.73,5.73,0,0,1,140,162Zm.08,3.93c0-4.1-2.81-5.91-5.29-5.91a5.95,5.95,0,0,0,0,11.85C137.22,171.83,140,169.88,140,165.89Z"
          />
          <path
            class="cls-2"
            d="M81,109.78c0,19.84-14.39,29.1-26.38,29.1-9.49,0-15.26-5.88-16.14-9.26v2.07a7.16,7.16,0,0,1-7.19,7.08,7.32,7.32,0,0,1-7.3-7.08V67.37a7.33,7.33,0,0,1,7.3-7.08,7.21,7.21,0,0,1,7.08,7.08V87a4.48,4.48,0,0,1,.11,1.2v1.86c2.18-5.13,8.4-9.27,16.14-9.27C66.5,80.78,81,90.37,81,109.78Zm-14.28,0C66.72,98.66,59.2,93,52,93c-6.1,0-14.17,4.47-14.17,16.79S45.9,126.56,52,126.56C59.2,126.56,66.72,121,66.72,109.78Z"
          />
          <path
            class="cls-2"
            d="M145.86,88.19v43.5a7.33,7.33,0,0,1-7.31,7.08,7.16,7.16,0,0,1-7.19-7.08v-2.07c-.87,3.38-6.65,9.26-16.13,9.26-12,0-26.38-9.26-26.38-29.1,0-19.41,14.49-29,26.38-29,7.74,0,14,4.14,16.13,9.27V88.19a7.23,7.23,0,0,1,7.19-7.08A7.41,7.41,0,0,1,145.86,88.19ZM132,109.78C132,97.46,124,93,117.84,93c-7.19,0-14.71,5.67-14.71,16.79s7.52,16.78,14.71,16.78C124,126.56,132,122.09,132,109.78Z"
          />
          <path
            class="cls-2"
            d="M197,87.43c0,4-3,6.76-9.15,6.76-8.62,0-14.07,6.65-14.61,11.12v26.27a7.14,7.14,0,0,1-14.28,0V88.3a7.14,7.14,0,1,1,14.28,0v5.45c.43-3.92,7.19-12.86,17-12.86C194.69,80.89,197,83.94,197,87.43Z"
          />
          <path
            class="cls-2"
            d="M272.78,71.7a5,5,0,0,1-5.34,5.12,17,17,0,0,1-4.58-1,9.29,9.29,0,0,0-3.7-.87c-6.11,0-6.87,5-6.87,7.2v3.27h8.94A5.4,5.4,0,0,1,267,91.1c0,3.27-2.29,5.56-5.77,5.56h-8.94v39a7.14,7.14,0,0,1-14.28,0v-39h-3.27c-3.49,0-5.78-2.29-5.78-5.56a5.41,5.41,0,0,1,5.78-5.66H238v-4c0-15.26,12.1-18.53,19.07-18.53A22.59,22.59,0,0,1,269,65.92C271.47,67.45,272.78,69.3,272.78,71.7Z"
          />
          <path
            class="cls-2"
            d="M331.32,91.54a7.28,7.28,0,0,1-.87,3.27l-28.24,63.55c-1.52,3.49-4.14,5-6.86,5A6.29,6.29,0,0,1,289,157a8.94,8.94,0,0,1,.77-3.27L296,139.5,275.73,94.81a8.94,8.94,0,0,1-.77-3.27,6.47,6.47,0,0,1,6.54-6.43c2.73,0,5.34,1.53,6.87,5L303,123.92l14.93-33.8c1.53-3.48,4-5,6.76-5A6.49,6.49,0,0,1,331.32,91.54Z"
          />
          <path
            class="cls-2"
            d="M213.51,139.39a7.26,7.26,0,0,0,7.19-7.19V89a7.14,7.14,0,1,0-14.28,0V132.2A7.24,7.24,0,0,0,213.51,139.39Z"
          />
          <circle class="cls-1" cx="335.57" cy="68.21" r="7" />
          <path
            class="cls-1"
            d="M205.67,182.51c-1.73,10.86.62,21.21,8.35,29.28s19,10.3,29.53,8.8c24.63-3.5,39.95-26.91,49.35-47.61,2.38-5.25-5.38-9.82-7.77-4.55-7.85,17.3-18.25,34.68-36.95,41.6-17.72,6.56-37.05-5-33.83-25.13.91-5.67-7.76-8.11-8.68-2.39Z"
          />
        </svg>
      </a>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex';
export default {
  data () {
    return {
      linkAppQrApple: 'https://apps.apple.com/es/app/id1533380602',
      linkAppQrAndroid: 'https://play.google.com/store/apps/details?id=com.servipyme.barify',
    };
  },
  computed: {
    ...mapGetters({
      closeModalAppPublic: 'getcloseModalAppPublic',
    }),
  },
  methods: {
    ...mapMutations({
      recoverCloseModalAppPublic: 'recoverCloseModalAppPublic',
    }),
    setModalAppPublic (value) {
      this.$store.commit('closeModalAppPublic', value);
    },
  },
  created () {
    this.recoverCloseModalAppPublic();
  },
};
</script>
<style>
.cls-1 {
  fill: #6cc6c0;
}
.cls-2 {
  fill: #d93b58;
}
.modalAppPublic a {
  text-decoration: underline;
}
</style>
